var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1793 35.1258C29.9882 35.1258 35.3548 26.9972 35.3548 19.9503C35.3548 19.7218 35.3497 19.4882 35.3396 19.2597C36.3835 18.5047 37.2845 17.5696 38 16.4982C37.0277 16.9308 35.9954 17.2133 34.9384 17.3361C36.0514 16.6689 36.8847 15.6209 37.284 14.3862C36.2369 15.0067 35.0919 15.4445 33.8979 15.6806C33.0934 14.8258 32.0297 14.2598 30.8713 14.0702C29.7129 13.8805 28.5243 14.0778 27.4892 14.6314C26.4541 15.185 25.6303 16.0642 25.145 17.133C24.6597 18.2019 24.54 19.4008 24.8045 20.5444C22.6844 20.4381 20.6103 19.8873 18.7166 18.9279C16.823 17.9685 15.1522 16.6218 13.8124 14.9753C13.1314 16.1493 12.9231 17.5386 13.2296 18.8607C13.5362 20.1829 14.3347 21.3387 15.4628 22.0933C14.6158 22.0664 13.7875 21.8384 13.0461 21.428V21.4941C13.0453 22.7261 13.4713 23.9204 14.2515 24.874C15.0317 25.8275 16.1181 26.4814 17.3259 26.7245C16.5414 26.9392 15.718 26.9705 14.9194 26.8159C15.2602 27.8755 15.9234 28.8023 16.8163 29.4668C17.7091 30.1314 18.7872 30.5006 19.9 30.523C18.0108 32.007 15.677 32.8119 13.2746 32.8081C12.8486 32.8075 12.4229 32.7814 12 32.7299C14.4406 34.2957 17.2797 35.1273 20.1793 35.1258Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8e5a9f3b.svg";
export { ForwardRef as ReactComponent };